// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"185ffdfbe5fb90a9801e","418":"9001edb610b8188e7776","661":"4c5637c0071dad5d6770"}[chunkId] + ".bundle.js";
};